import { FormikHelpers, Formik, Form } from "formik";
import _ from "lodash";
import { useSnackbar } from "notistack";
import * as yup from "yup";

import { Card, CardHeader, CardContent } from "@material-ui/core";

import { useTenant } from "src/components/LoggedInAdminProvider";
import FormikErrorBanner from "src/components/form/FormikErrorBanner";
import FormikTextField from "src/components/form/FormikTextField";
import SubmitButton from "src/components/form/SubmitButton";
import {
  tenantEditOutboundPoolSize,
  tenantEditOutboundPoolSizeVariables
} from "src/graphql/generated/tenantEditOutboundPoolSize";
import { EDIT_TENANT_OUTBOUND_POOL_SIZE } from "src/graphql/tenant";
import useMutation from "src/util/useMutation";

import { numberAsStringField } from "./common";

type Values = { outboundPoolSize: string };
export default function Basics(): JSX.Element {
  const tenant = useTenant()!;
  const snackbar = useSnackbar();

  const schema = yup.object().shape({
    outboundPoolSize: yup.number().nullable().positive().integer()
  });

  const [updateTenantOutboundPoolSize] = useMutation<
    tenantEditOutboundPoolSize,
    tenantEditOutboundPoolSizeVariables
  >(EDIT_TENANT_OUTBOUND_POOL_SIZE, {
    onErrorSnackbarMessage: `Failed to update organization settings.`
  });

  async function handleSubmit(values: Values, helpers: FormikHelpers<Values>) {
    const newOutboundPoolSize =
      (values.outboundPoolSize && _.parseInt(values.outboundPoolSize)) || null;
    const { errors, data } = await updateTenantOutboundPoolSize({
      variables: { newOutboundPoolSize }
    });

    if (!errors) {
      snackbar.enqueueSnackbar("Organization updated.", { variant: "info" });
      helpers.resetForm({
        values: {
          outboundPoolSize: numberAsStringField(
            data!.tenantEditOutboundPoolSize.minimumOutgoingNumberPoolSize
          )
        }
      });
    }
  }

  return (
    <>
      <Card>
        <CardHeader title="Minimum Outbound Pool Size" />
        <CardContent>
          <Formik
            initialValues={{
              outboundPoolSize: numberAsStringField(
                tenant.minimumOutgoingNumberPoolSize
              )
            }}
            onSubmit={handleSubmit}
            validationSchema={schema}
          >
            {({ isSubmitting, dirty }) => (
              <Form>
                <FormikErrorBanner />
                <FormikTextField
                  fullWidth
                  label="Outbound pool size"
                  name="outboundPoolSize"
                  disabled={isSubmitting}
                />
                <SubmitButton
                  type="submit"
                  disabled={!dirty}
                  isSubmitting={isSubmitting}
                  submitText="Update"
                  loadingText="Updating..."
                />
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </>
  );
}
